import { ref, set } from "firebase/database";
import { db } from "../lib/firebase";

import { LaunchError } from "../utils/errors";
import { store } from "../app/store";

export const ackOptimisticSwitch = (operationId) => {
  const id = String(operationId || "").trim();
  if (!id) return Promise.resolve();

  return set(ref(db, `optimisticSwitchOps/${id}/ackTime`), Date.now()).catch(
    (error) => {
      store.dispatch(
        LaunchError(error, false, [], {
          functionName: "ackOptimisticSwitch",
          capture: "exception",
        })
      );
      console.error("optimisticSwitch.ack", error);
    }
  );
};
